import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
// import seeMailBaoSiModel from './modelForm/seeMailBaoSi.vue';
// import mailModel from './modelForm/mailModel.vue';
import tagList from '@/components/tagList.vue';
// import closeCaseModel from './modelForm/closeCaseModel.vue';
import { applicationResource } from './../../customer/applicationManage/request'; //保单来源接口
import { insuranceResource } from './../../insurance/insuranceManage/request'; //产品名字接口
import { resultSelectList, statusSelectList, auditSelectList } from './utils';
import { claimsList, getTags } from './request';
import { mapState } from 'vuex';
import downloadModel from './modelForm/downloadModel.vue';
import clickShowTag from '@/components/clickShowTag.vue';
import tagModel from '@/components/tagModel.vue';
export default {
  components: {
    downloadModel,
    clickShowTag,
    tagModel,
    tagList
  },
  data() {
    return {
      columns: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      resultSelectList,
      statusSelectList,
      auditSelectList,
      form: {
        policyNo: '',
        insuranceId: undefined,
        result: undefined,
        status: undefined,
        createAt: '',
        isClose: undefined,
        applicationId: undefined
      },
      tableData: [{
        id: 1
      }],
      productionSelectList: [],
      sourceSelectList: [],
      seeMailShow: false,
      mailShow: false,
      mailWriteShow: false,
      closeCaseShow: false,
      seeMailBaoSiShow: false,
      downloadShow: false,
      showItem: false,
      tagShow: false,
      tagData: [],
      tagList: [],
      currentThis: this
    };
  },
  filters: {
    typeFilters(val, item, tag, currentThis) {
      let cont = '';
      switch (val) {
        case 1:
          cont = currentThis.$t('提交报案信息');
          break;
        case 2:
          cont = currentThis.$t('审核中');
          break;
        case 3:
          cont = tag == 0 ? currentThis.$t('需补充完善资料') : currentThis.$t('等待完善资料');
          break;
        case 4:
          cont = currentThis.$t('完善资料已提交');
          break;
        case 5:
          cont = currentThis.$t('审核通过');
          break;
        case 6:
          cont = currentThis.$t('拒绝赔付');
          break;
        case 7:
          if (tag == 1) {
            cont = currentThis.$t('填写邮寄信息');
          } else {
            cont = currentThis.$t('等待保司回复邮寄信息');
          }
          break;
        case 8:
          if (tag == 1) {
            cont = currentThis.$t('等待邮寄单证');
          } else {
            cont = currentThis.$t('请邮寄单证');
          }
          break;
        case 9:
          if (item._status == 1) {
            cont = currentThis.$t('待打款');
          } else {
            cont = currentThis.$t('拒绝赔付');
          }
          break;
        case 10:
          if (item._status == 1) {
            cont = currentThis.$t('已打款');
          } else {
            cont = currentThis.$t('拒绝赔付');
          }
      }
      return cont;
    }
  },
  created() {
    this.getSelectList();
    this.searchFun();
    // setTimeout(()=>{
    //   this.columns=this.tag==0?columns:columns2;
    // },400);
  },
  computed: {
    ...mapState({
      customerId: state => state.user.accountInfo.customerId,
      tag: state => state.user.accountInfo.tag
    })
  },
  methods: {
    async getSelectList() {
      this.sourceSelectList = await applicationResource({
        customerId: this.customerId,
        position: 'claims'
      });
      this.productionSelectList = await insuranceResource({
        customerId: this.customerId
      });
      this.tagData = await getTags({});
    },
    async searchFun() {
      //   this.pagination.total = totalNum;
      this.pagination.current = 1;
      this.getListData();
    },
    async getListData() {
      const h = this.$createElement;
      const {
        items,
        totalNum,
        fieldConfig
      } = await claimsList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      if (fieldConfig) {
        this.columns = fieldConfig.map(item => {
          let obj = item;
          obj.slots = {
            title: obj.title
          };
          delete obj.title;
          if (item.ellipsis) {
            obj.customRender = text => h("a-tooltip", {
              "attrs": {
                "placement": "topLeft",
                "title": text
              }
            }, [text]);
          } else if (item.dataIndex == 'status') {
            obj.customRender = text => {
              if (text === 0) {
                return this.$t('审核中');
              } else if (text === 1) {
                return this.$t('审核通过');
              }
              return this.$t('审核未通过');
            };
          } else if (item.dataIndex == 'isClose') {
            obj.customRender = text => {
              return text === 0 ? this.$t('未结案') : this.$t('已结案');
            };
          }
          return obj;
        });
        this.columns.push({
          slots: {
            title: '操作'
          },
          dataIndex: 'operation',
          key: 'operation',
          align: 'center',
          width: 250,
          scopedSlots: {
            customRender: 'operation'
          }
        });
      }
      this.tableData = items;
      this.pagination.total = totalNum;
      // let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      // if (
      //   this.pagination.page === lastPage + 1 &&
      //   this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0
      // ) {
      //   this.pagination.page -= 1;
      //   this.pagination.current -= 1;
      //   this.getListData();
      // }
    },
    resetSearch() {
      this.form.policyNo = '';
      this.form.createAt = '';
      this.form.result = undefined;
      this.form.insuranceId = undefined;
      this.form.status = undefined;
      this.form.isClose = undefined;
      this.form.applicationId = undefined;
    },
    onDetail() {},
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    },
    handleMail(val) {
      this.seeMailShow = true;
      this.$nextTick(() => {
        this.$refs.seeMailFrom.init(val.id);
      });
    },
    handleMailBaoSi(val) {
      if (val.isMailing == 2) {
        this.seeMailBaoSiShow = true;
        this.$nextTick(() => {
          this.$refs.seeMailBaosiFrom.init(val.id);
        });
      } else {
        this.mailShow = true;
        this.$nextTick(() => {
          this.$refs.mailFrom.init(val.id);
        });
      }
    },
    handleMailWrite(val) {
      this.mailWriteShow = true;
      this.$nextTick(() => {
        this.$refs.mailWriteFrom.init(val.id);
      });
    },
    handleCloseCase(val) {
      this.closeCaseShow = true;
      this.$nextTick(() => {
        this.$refs.closeCaseFrom.init(val.id);
      });
    },
    tagOk(arr, arr2, arrVaule) {
      this.form.tags = arrVaule;
      this.tagList = arr;
      console.log(arr, arr2, arrVaule);
      if (arr2.length != 0) {
        this.tagList.push(arr2);
      }
      this.searchFun();
    },
    tagListOk(arr, arr2, arrVaule) {
      this.tagData = arr;
      this.tagList = arr2;
      this.form.tags = arrVaule;
      this.searchFun();
    }
  }
};